export enum ScrollDragEnums {
	SCROLL_END_DEBOUNCE = 300,
	ActivationDistance = 10,
}
